import React from 'react'
import { connect } from 'react-redux';
import { setFondDeCarte } from '../redux/actions'

function FondDeCarte({ fonddecarte, setFondDeCarte }) {

    var ChangerFondDeCarte = (val) => {
        setFondDeCarte(val.target.value);
    };

    return (
        <div className="col-6">Fond de carte
            <br />
            <select id="fondcarte" className="semi-square" value={fonddecarte} onChange={ChangerFondDeCarte}>
                <option id="esri">ESRI</option>
                <option id="openstreepmap">OpenStreetMap</option>
                <option id="orthophoto">Orthophoto</option>
                <option id="Fond_gris"> Fond gris</option>
                <option id="Topographie">Topographie</option>
            </select>
        </div>
    )
}


function mapStateToProps(state) {

    return {
        fonddecarte: state.fonddecarte
    }
}

export default connect(mapStateToProps, { setFondDeCarte })(FondDeCarte);